export enum RailTrackTypeEnum {
  TwoTrack,
  ThreeTrack
}
